export const normalizeFileType = (fileType?: string, fileName?: string) => {
	fileType = fileType || 'unknown';
	const fileTypePieces = fileType.split('/');
	if (fileTypePieces[1]) fileType = fileTypePieces[1];
	switch (fileType) {
		case 'mpeg':
			if (fileName?.endsWith('.mp3')) return 'mp3';
	}
	return fileType.replace(/^x-/, '');
};

export default normalizeFileType;
